/* global require */

import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookie from 'vue-cookie'
import VueRouter from 'vue-router'
import Quiz from './quiz.vue'
import Results from './results.vue'
import { analytics } from 'shiseido-apis'
import '../scss/suncarefinder.scss'

Vue.use(VueResource)
Vue.use(VueCookie)
Vue.use(VueRouter)

const VueScrollTo = require('vue-scrollto')

const router = new VueRouter({
    routes: [
        { name: 'product',   path: '/', component: Quiz },
        { name: 'protect',   path: '/:product/', component: Quiz },
        { name: 'coverage',  path: '/:product/:protect/', component: Quiz },
        { name: 'lifestyle', path: '/:product/:protect/:formula/', component: Quiz },
        { name: 'results',   path: '/:product/:protect/:formula/:lifestyle', component: Results },
        { name: 'default',   path: '*', redirect: '/' },
    ],
})

new Vue({
    router,
    watch: {
        $route: 'trackPageView',
    },
    mounted() {
        if (this.$route.name === 'product') {
            setTimeout(() => {
                VueScrollTo.scrollTo('#suncarefinder', 500, { offset: -60 })

                analytics.registerPageView({
                    toolname: 'Suncare Finder',
                    pagename: 'intro/product',
                })
            }, 1500)
        } else if (this.$route.name === 'intro') {
            setTimeout(() => {
                analytics.registerPageView({
                    toolname: 'Suncare Finder',
                    pagename: 'intro',
                })
            }, 1500)
        }

        this.loadSavedConsultation()
    },
    methods: {
        onNext(path) {
            router.push({ path })
        },
        loadSavedConsultation() {},
        trackPageView() {
            analytics.registerPageView({
                toolname: 'Suncare Finder',
                pagename: this.$route.name,
            })
        },
    },
}).$mount('#suncarefinder')

Vue.config.productionTip = false


// WEBPACK FOOTER //
// ./development/js/app.js